/* eslint-disable react-hooks/exhaustive-deps */
import React, { useLayoutEffect, useState, useRef } from "react";
import { Layout, Card, Table, Tag, Button, Space } from "antd";

import LayoutHeader from "../../inc/LayoutHeader";
import LayoutFooter from "../../inc/LayoutFooter";

import { getAPI } from "../../../utils/common";
import { KITCHEN_LOW_STOCK_REPORT } from "../../../constants/api";
import LS_SERVICE from "../../../utils/localStorage";
import dayjs from "dayjs";
import { PROJECT_NAME } from "../../../constants/constent";

function KitchenLowStockReport() {
  const { Content } = Layout;
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);
  const { company_name } = LS_SERVICE.get("setting") || {};
  const [printMode, setPrintMode] = useState(false);
  const printRef = useRef();

  useLayoutEffect(() => {
    getAPI(
      KITCHEN_LOW_STOCK_REPORT,
      (res) => {
        if (res.status) setData(res.data);
        setLoading(false);
      },
      () => setLoading(false),
    );
  }, []);

  const handlePrint = () => {
    const printContents = printRef.current.innerHTML;
    const originalContents = document.body.innerHTML;

    document.body.innerHTML = printContents;
    window.print();
    document.body.innerHTML = originalContents;
    window.location.reload(); // reload to restore React app
  };

  const columns = [
    { title: "S.No", render: (_, __, i) => i + 1 },
    { title: "Item Name", dataIndex: "name" },
    { title: "Current Stock", dataIndex: "current_stock" },
    { title: "Reorder Level", dataIndex: "reorder_level" },
    {
      title: "Status",
      render: () => <Tag color="red">Low Stock</Tag>,
    },
  ];

  return (
    <Layout>
      <LayoutHeader />
      <Content>
        <Card
          title="Low Stock Alert"
          extra={
            <Space>
              <Button
                type="primary"
                onClick={() => {
                  setPrintMode(true); // printMode flag
                  setTimeout(() => {
                    handlePrint();
                    setPrintMode(false); // restore after print
                  }, 500);
                }}
              >
                Print Report
              </Button>
            </Space>
          }
        >
          <div ref={printRef}>
            {/* Header for print */}
            {printMode && (
              <div style={{ textAlign: "center", marginBottom: 20 }}>
                <h2>{company_name || PROJECT_NAME} Low Stock Report</h2>
                <h3>Date: {dayjs().format("YYYY-MM-DD")}</h3>
              </div>
            )}

            <Table
              loading={loading}
              columns={columns}
              dataSource={data}
              rowKey="id"
              pagination={printMode ? false : { pageSize: 10 }} // disable pagination while printing
            />
          </div>
        </Card>
      </Content>
      <LayoutFooter />
    </Layout>
  );
}

export default KitchenLowStockReport;
